import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Progress, Stack } from '@chakra-ui/react';
import { ESummaryStatus, hasValue } from '@kcast-fe/core';
const colorMap = {
    [ESummaryStatus.Ready]: '{colors.stateSuccess}',
    [ESummaryStatus.Replaying]: '{colors.stateWarn}',
    [ESummaryStatus.Failed]: '{colors.stateError}'
};
const labelMap = {
    [ESummaryStatus.Ready]: 'Active',
    [ESummaryStatus.Replaying]: 'Replaying…',
    [ESummaryStatus.Failed]: 'Replay failed'
};
const SummaryStatusBadgeFC = ({ status, replaying_progress }) => {
    if (status === ESummaryStatus.Replaying) {
        return (_jsxs(Stack, { pr: '12px', gap: 0, children: [_jsx(Box, { fontSize: '13px', fontWeight: '500', color: '{colors.textTertiary}', children: `Replaying ${hasValue(replaying_progress) ? Math.round(replaying_progress * 100) : 0}% ...` }), _jsx(Progress.Root, { size: 'sm', colorPalette: 'gray', value: hasValue(replaying_progress) ? replaying_progress * 100 : 0, children: _jsx(Progress.Track, { borderRadius: '4px', children: _jsx(Progress.Range, { transition: 'width 200ms ease-in-out' }) }) })] }));
    }
    return (_jsx(Box, { gap: '8px', display: 'inline-flex', alignItems: 'center', px: '10px', py: '2px', borderRadius: 'full', fontSize: '14px', fontWeight: '500', color: colorMap[status], bg: `color-mix(in srgb, ${colorMap[status]} 12%, transparent)`, children: labelMap[status] }));
};
export const SummaryBadge = SummaryStatusBadgeFC;
//# sourceMappingURL=SummaryBadge.js.map